/**
 * Pre-compiled pt-BR messages for Avatar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  avatarLabel: (args: Record<string, string | number>) =>
    `Avatar para ${args.fullName}`,
  avatarLabelGeneric: `Generic user avatar`,
};
